import { useWindyMapStore } from "@/stores/windy-map-store";
import { useEffect, useState } from "react";
import geojson from "@/geojson";
import ReactDOMServer from "react-dom/server";

type GeojsonKey = keyof typeof geojson;
import * as L from "leaflet";
import { useParams } from "react-router-dom";
import { usePhenoQuery } from "@/query/pheno-query";
import PhenoPopup from "@/components/pheno-popup";
import PhenoWidget from "@/components/pheno-widget";
import Fore3hourWidget from "@/components/fore3hour-widget";
import useAlertQuery from "@/query/alert-query";
import AlertWidget from "@/components/alert-widget";
import { regions } from "@/utils/region";

const PhenoPage: React.FC = () => {
  const { type } = useParams<{
    type:
      | "western"
      | "eastern"
      | "central"
      | "gobi"
      | "cities"
      | "erdenet"
      | "darkhan"
      | "ulaanbaatar";
  }>();
  if (!type || !regions[type]) {
    return <></>; // Handle invalid type
  }
  const { location, zoom } = regions[type];
  const geojsonKeys = regions[type].regions;

  const { data: alertData } = useAlertQuery();
  const { data: phenoData } = usePhenoQuery(type);
  const windyLayer = useWindyMapStore((state) => state.layer);
  const windyMap = useWindyMapStore((state) => state.windyMap);
  const [groupLayer, setGroupLayer] = useState<any>();

  useEffect(() => {
    if (!windyLayer) return;
    console.log("wind layer", windyLayer);

    const newLayer = L.layerGroup().addTo(windyLayer);
    // const newPhenoLayer = L.layerGroup().addTo(layer);
    if (groupLayer) {
      groupLayer.remove();
    }

    setGroupLayer(newLayer);
    return () => {
      newLayer.remove();
    };
  }, [windyLayer]);
  useEffect(() => {
    if (!groupLayer || !windyMap || !phenoData) return;

    groupLayer.clearLayers();
    geojsonKeys.map((name) => {
      const geoData = geojson[name as GeojsonKey];
      L.geoJSON(geoData, {
        style: {
          color: "#4D0368",
        },
      }).addTo(groupLayer);
      const { properties } = geoData;
      if (properties && properties.location && properties.name) {
        const pheno =
          phenoData.find(
            (item) =>
              item.city === properties.name ||
              (properties.name === "Эрдэнэт" && item.city === "Эрдэнэт-Овоо") ||
              (properties.name === "Чингис" && item.city === "Өндөрхаан") ||
              (properties.name === "Налайх" && item.city === "Тэрэлж")
          ) || null;
        if (!pheno) return;
        pheno.city = properties.name;
        const htmlString = ReactDOMServer.renderToString(
          <PhenoPopup pheno={pheno} />
        );
        console.log("htmltsring", htmlString);
        const [lat, lng] = properties.location;
        L.marker([Number(lat), Number(lng)])
          .addTo(groupLayer)
          .bindPopup(htmlString, {
            closeButton: false,
            autoClose: false,
            closeOnEscapeKey: false,
            closeOnClick: false,
            className: "my-popup weather-pheno",
          })
          .openPopup();
      }
    });

    windyMap.setView(location, zoom);
  }, [groupLayer, windyMap, phenoData]);
  return (
    <>
      {["darkhan", "erdenet", "ulaanbaatar"].includes(type) && (
        <PhenoWidget type={type} />
      )}
      {["ulaanbaatar"].includes(type) && <Fore3hourWidget />}
      {alertData &&
        Object.keys(alertData).length > 0 &&
        [
          "darkhan",
          "erdenet",
          "ulaanbaatar",
          "eastern",
          "western",
          "central",
          "gobi",
        ].includes(type) && <AlertWidget type={type} />}
    </>
  );
};

export default PhenoPage;
